import styled from "styled-components";

export const ButtonWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: end;
`;
